export default __webpack_public_path__ + "static/media/2.7f65e9f5.png";